import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const StyledSection = styled.div`
  animation: ${fadeIn} 300ms ease-in;
  padding: ${props => props.padding || '5rem'};
  min-height: ${props => props.minHeight || 'calc(100vh - 10rem)'};
  height: ${props => props.height || 'fit-content'};
  max-width: ${props => props.maxWidth || '1400px'};
  display: flex;
  flex-direction: ${props => props.direction || 'column'};
  align-items: ${props => props.alignItems || 'center'};
  justify-content: ${props => props.justifyContent || 'center'};

  @media (max-width: 768px) {
    padding: ${props => props.mobilePadding || '8rem 1rem'};
    justify-content: ${props => props.mobileJustifyContent || 'flex-start'};
  }
`;

const Section = ({ 
  children, 
  padding,
  minHeight,
  height,
  maxWidth,
  direction,
  alignItems,
  justifyContent,
  mobilePadding,
  mobileJustifyContent,
  ...props 
}) => {
  return (
    <StyledSection
      padding={padding}
      minHeight={minHeight}
      height={height}
      maxWidth={maxWidth}
      direction={direction}
      alignItems={alignItems}
      justifyContent={justifyContent}
      mobilePadding={mobilePadding}
      mobileJustifyContent={mobileJustifyContent}
      {...props}
    >
      {children}
    </StyledSection>
  );
};

export default Section;